import React from 'react';
import { Link } from 'react-router-dom';

function HomeScreen() {
  return (
    <>
      <div className="hero-section-wrapper">
        <main className="main-container">
          <section className="first-section">
            <div className="text-section">
              <div className="sub-headline-row">
                <span className="hero-pill">
                  <span className="hero-pill-dot"></span>
                  #1 AI Viral Video Generator
                </span>
              </div>
              <h2>
                Turn any image into a viral social media video
              </h2>
              <p>
                Upload one image of yourself, a friend, or even a Barbie doll. PinkCatAI turns it into a scroll-stopping viral video built for TikTok, Reels &amp; Shorts. No editing, no studio, just pink magic.
              </p>
              <div className="button-wrapper">
                <Link to="/dashboard">
                  <button className="start-button">
                    Create your viral video
                    <svg className="arrow-thin" viewBox="0 0 24 24" width="16" height="16" stroke="currentColor" strokeWidth="1.5" fill="none" strokeLinecap="round" strokeLinejoin="round">
                      <path d="M5 12h14M12 5l7 7-7 7" />
                    </svg>
                  </button>
                </Link>
                <p className="no-credit-card">Free trial &middot; No credit card required</p>
                <div className="hero-social-proof">
                  <div className="hero-social-proof-avatars">
                    <img src="https://i.pravatar.cc/150?img=11" alt="" />
                    <img src="https://i.pravatar.cc/150?img=22" alt="" />
                    <img src="https://i.pravatar.cc/150?img=33" alt="" />
                    <img src="https://i.pravatar.cc/150?img=44" alt="" />
                    <img src="https://i.pravatar.cc/150?img=55" alt="" />
                  </div>
                  <div className="hero-social-proof-right">
                    <span className="hero-social-proof-stars">★★★★★</span>
                    <div className="hero-social-proof-text-block">
                      <span className="hero-social-proof-number">2,964+</span>
                      <span className="hero-social-proof-text">creators going viral</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="image-section">
              <img
                src="https://r2.pinkcatai.com/Media/Unbenannt-9-25.png"
                alt="Upload any photo and turn it into a viral social media video"
                className="hero-image"
              />
            </div>
          </section>
        </main>
      </div>

      <div className="steps-boundary-wrapper">
        <div className="how-it-works-card">
          <div className="how-it-works-steps">
            <div className="how-step">
              <div className="how-step-icon"><img src="https://r2.jewlai.com/Media/Unbenannt-9-19.png" alt="" /></div>
              <div className="how-step-text">
                <strong>Step 1:</strong>
                <span className="how-step-desc">Upload or create any image</span>
              </div>
            </div>
            <div className="how-step-arrow" aria-hidden="true"><img src="https://r2.jewlai.com/Media/Unbenannt-9-17.png" alt="" /></div>
            <div className="how-step">
              <div className="how-step-icon"><img src="https://r2.jewlai.com/Media/Unbenannt-9-20.png" alt="" /></div>
              <div className="how-step-text">
                <strong>Step 2:</strong>
                <span className="how-step-desc">AI makes your viral video</span>
              </div>
            </div>
            <div className="how-step-arrow" aria-hidden="true"><img src="https://r2.jewlai.com/Media/Unbenannt-9-17.png" alt="" /></div>
            <div className="how-step">
              <div className="how-step-icon"><img src="/step-phone.png" alt="" /></div>
              <div className="how-step-text">
                <strong>Step 3:</strong>
                <span className="how-step-desc">Post and go viral</span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="below-hero-section">
        <div className="below-hero-inner">
          <div className="how-it-works-features">
            <ul className="how-features-list">
              <li><span className="check-icon">✓</span> Use your own face or any image</li>
              <li><span className="check-icon">✓</span> Built for TikTok, Reels &amp; Shorts</li>
              <li><span className="check-icon">✓</span> New viral styles added every week</li>
            </ul>
          </div>
        </div>
      </div>

      <div className="testimonials-section-wrapper">
        <div className="testimonials-section-inner">
          <section className="testimonials-section">
            <h2 className="section-title-with-decoration">
              <span className="title-decoration">˙⋆✮</span>
              Loved by creators
              <span className="title-decoration title-decoration-right">˙⋆✮</span>
            </h2>
            <p className="testimonials-subtitle">
              Real creators using PinkCatAI to grow their socials
            </p>
            <div className="testimonials-grid">
              <article className="testimonial-card">
                <div className="testimonial-stars">★★★★★</div>
                <p className="testimonial-quote">
                  &ldquo;Posted my first PinkCat video on Tuesday. By Thursday it had 412k views. I literally just uploaded a selfie. This is unfair.&rdquo;
                </p>
                <div className="testimonial-author">
                  <img src="https://i.pravatar.cc/150?img=47" alt="" className="testimonial-avatar" />
                  <div className="testimonial-author-info">
                    <span className="testimonial-author-name">Mia R.</span>
                    <span className="testimonial-author-role">TikTok creator &middot; 180k followers</span>
                  </div>
                </div>
              </article>
              <article className="testimonial-card">
                <div className="testimonial-stars">★★★★★</div>
                <p className="testimonial-quote">
                  &ldquo;I run a small fashion brand. The Barbie video with our model went viral on Reels and crashed our Shopify. Best 90 seconds I ever spent.&rdquo;
                </p>
                <div className="testimonial-author">
                  <img src="https://i.pravatar.cc/150?img=25" alt="" className="testimonial-avatar" />
                  <div className="testimonial-author-info">
                    <span className="testimonial-author-name">Sofia L.</span>
                    <span className="testimonial-author-role">Founder &middot; pinkbloom.shop</span>
                  </div>
                </div>
              </article>
              <article className="testimonial-card">
                <div className="testimonial-stars">★★★★★</div>
                <p className="testimonial-quote">
                  &ldquo;CapCut took me hours. PinkCatAI takes me 90 seconds and the videos look 10x better. I&rsquo;m not editing manually ever again.&rdquo;
                </p>
                <div className="testimonial-author">
                  <img src="https://i.pravatar.cc/150?img=68" alt="" className="testimonial-avatar" />
                  <div className="testimonial-author-info">
                    <span className="testimonial-author-name">Jordan K.</span>
                    <span className="testimonial-author-role">Content creator &middot; YouTube Shorts</span>
                  </div>
                </div>
              </article>
            </div>
          </section>
        </div>
      </div>
    </>
  );
}

export default HomeScreen;
